var selector = {
        container: '.post',
        img: '.thumbnail img',
        colors: '.colors',
        colorItem: '.color',
        capacityTableContainer: '.summary.entry-summary',
        capacityTable: '.capacities-table tbody',
        price: '.product .summary .price',
        addToCart: '.product .summary span.add-to-cart',
        commonTable: '.product .summary table.common',
        commonNotInStockTable: '.product .common-not-in-stock',
        productIdInputAtQuickOrder: '#quick-order-product-id'
    },
    anim,
    colors = $(selector.colors).first(),
    colorsAll = $(selector.colors),
    is_color_auto_selected = false,
    self = this;

var Basket = require('./checkout/basket');

if (pageType == 'ProductProductCommon') {
    selector.img = '.images img';
    $(selector.capacityTable).each(function (i, el) {
        el = $(el);
        $(selector.capacityTableContainer).on('click', selector.capacityTable + ' tr', onCapacityClick);
    });
    $(selector.capacityTable).each(function (i, el) {
        el = $(el);
        el.find('tr').css({cursor: 'pointer'});
    });

    colorsAll.each(function (i, el) {
        el = $(el);
        el.find(selector.colorItem).each(function (i, colorItem) {
            colorItem = $(colorItem);
            colorItem.on('click', onColorClick);
        });
    });
}


if (pageType == 'ProductCategoryCommon') {
    $('#shop-posts-list').on('click', selector.colorItem, onColorClick);
}

if (pageType == 'ProductProductCommon') {
    is_color_auto_selected = false;
    if (document.location.hash != '') {
        var colorNameTranslit = document.location.hash.replace(/#/, '');
        colors.find(selector.colorItem).each(function (i, colorItem) {
            colorItem = $(colorItem);
            if (colorItem.attr('data-parameter_color_translit') == colorNameTranslit) {
                colorItem[0].click();
                is_color_auto_selected = true;
            }
        });
    }

    if (false && !is_color_auto_selected) {
        colorsAll.each(function (i, el) {
            el = $(el);
            colors.find(selector.colorItem)[0].click();
        });
    }
}

function onColorClick(ev) {
    var container = $(this).parents(selector.container).first(),
        product_id = $(this).attr('data-product_id'),
        image_src = $(this).attr('data-image_src'),
        image_src_big = $(this).attr('data-image_src_big'),
        capacity_to_price = $(this).attr('data-capacity_to_price'),
        capacity_to_product_id = $(this).attr('data-capacity_to_product_id'),
        capacityTables = container.find(selector.capacityTable),
        previousColor = container.find(selector.colorItem + '.active'),
        parameter_color = $(this).attr('data-parameter_color'),
        parameter_color_translit = $(this).attr('data-parameter_color_translit'),
        colorItem = $(this),
        img = container.find(selector.img).first(),
        phoneNumber = $('.call-to-us + i + a').html(),
        image = new Image;

    image.src = image_src;

    previousColor.removeClass('active');
    container.find(selector.colorItem).each(function (i, el) {
        el = $(el);
        if (el.attr('data-parameter_color') == colorItem.attr('data-parameter_color')) {
            el.addClass('active');
        }
    });
    if (pageType == 'ProductCategoryCommon') {
        container.find('a:not(.portfolio-link)').each(function (i, a) {
            a = $(a);
            a.attr('href', a.attr('href').replace(/#.+/, '#' + parameter_color_translit));
        });
    }
    if (pageType == 'ProductProductCommon' && (document.location.hash != '#drawinglogo')) {
        document.location.hash = '#' + parameter_color_translit;
    }

    img.css('opacity', 0.2);

    if (pageType == 'ProductProductCommon') {
        img.parents('a').first().attr('href', image_src_big);
        capacity_to_price = JSON.parse(capacity_to_price);
        capacity_to_product_id = JSON.parse(capacity_to_product_id);
        capacityTables.each(function (i, capacityTable) {
            capacityTable = $(capacityTable);
            capacityTable.html('');
            for (var capacity in capacity_to_price) {
                var price = parseFloat(capacity_to_price[capacity]);
                var productId = capacity_to_product_id[capacity];
                capacityTable.append('<tr data-product_id="' + productId + '"><td class="capacity">' + capacity + '</td><td class="capacity-price" data-price="' + price + '">' + (price > 0.0 ? Basket.getPriceFormatted(price, null, false) : '—') + '</td></tr>');
            }
            capacityTable.find('tr').css({cursor: 'pointer'});
        });

        /*capacityTables.each(function (i, capacityTable) {
            capacityTable = $(capacityTable);
            capacityTable.find('tr')[0].click();
            capacityTable.find('tr').addClass('active');
        })*/
    }
    img.attr('src', image_src);
    img.attr('id', 'image' + product_id);
    img.css('opacity', 1);
}

function onCapacityClick(ev) {

    var container = $(selector.container),
        price = $(selector.price),
        addToCart = $(selector.addToCart),
        capacityTables = container.find(selector.capacityTable),
        img = container.find(selector.img),
        nodeQuantity = $('#product-quantity'),
        rightPart = $(this).find('td').eq(1),
        rightPartContent = rightPart.html(),
        product_id = $(this).attr('data-product_id'),
        priceContainer = price.eq(0).parents('div').first(),
        quantityContainer = nodeQuantity.parents('div').first(),
        isExistsDimmer = false,
        commonTable = $(selector.commonTable),
        commonNotInStockTable = $(selector.commonNotInStockTable),
        productIdInputAtQuickOrder = $(selector.productIdInputAtQuickOrder);

    capacityTable = $(this).parents('table').first();
    //capacityTables.each(function(capacityTable) {
    if (capacityTable.find('tr.active').length) {
        capacityTable.find('tr.active').removeClass('active');
    }
    //});

    $(this).addClass('active');

    if (rightPart.data('price') > 0) {
        price.html(rightPart.html());
        if (commonTable.css('display') == 'none') commonTable.css('display', 'table');
        if (commonNotInStockTable.css('display') == 'table') commonNotInStockTable.css('display', 'none');
        addToCart.each(function (i, el) {
            el = $(el);
            el.find('a').attr('data-product_id', product_id);
        });
        productIdInputAtQuickOrder.attr('value', product_id);
    }
    else {
        commonNotInStockTable.css('height', commonTable.height());
        commonTable.css('display', 'none');
        commonNotInStockTable.css('display', 'table');
    }

    nodeQuantity.attr('name', 'quantity' + product_id);
    img.attr('id', 'image' + product_id);

    if (priceContainer.find('.dimmer').length) {
        isExistsDimmer = true;
    }
    if (!(parseInt(rightPartContent) > 0)) {
        if (!isExistsDimmer) {
            priceContainer
                .append('<div class="ui active inverted dimmer"></div>')
                .css({
                    position: 'relative'
                })
            ;
            quantityContainer
                .append('<div class="ui active inverted dimmer"></div>')
                .css({
                    position: 'relative'
                })
            ;
        }
    } else {
        if (isExistsDimmer) {
            priceContainer.find('.dimmer').remove();
            quantityContainer.find('.dimmer').remove();
        }
    }
}


// WEBPACK FOOTER //
// ./assets/javascript/commoncolors.js